// extracted by mini-css-extract-plugin
export default {"certifications":"Certifications_certifications__Asdq3","cardHeader":"Certifications_cardHeader__M3Ib1","grid3":"Certifications_grid3__m+3dm"};